import { withVariants, Table } from '@hvccc/component-library';

const styles = {
  standard: Table,
};

export default withVariants(styles)(Table);
